import { createSlice } from "@reduxjs/toolkit";
import {
    getAgentWithoutTeamThunk,
    getUserTeamGetTeamsThunk,
} from "tm-shared/api";

import { HRState } from "./hr.slice.types";

const initialState: HRState = {
    teams: null,
    freeMembers: null,
};

export const HRSlice = createSlice({
    name: "hr",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserTeamGetTeamsThunk.fulfilled, (state, action) => {
                state.teams = action.payload.result;
            })

            .addCase(getAgentWithoutTeamThunk.fulfilled, (state, action) => {
                state.freeMembers = action.payload.result;
            });
    },
});

export default HRSlice.reducer;
